export const APP_VERSION = "1.0.0";
export const BUILD_ID = "1.0.0-1785616935008";
export const BUILD_GENERATED_AT = "2026-08-01T20:42:15.008Z";
